<div class="p-grid workStyle">
    <div class="p-col-12 p-md-8">
        <div class="p-grid">
            <div class="p-col-12 p-md-6 header">
                Tree {{type}} [<span class="link" (click)="navigate()">{{workOrder.quoteNumber}}</span>] <span style="font-weight: normal;">{{workOrder.address.street}}, {{workOrder.address.city}}, {{workOrder.address.state.abbreviation}} {{workOrder.address.zip}}</span>
            </div>
            <div class="p-col-2 hide-sm" style="text-align: right; font-weight: bold;">
                @if (canSeeHiddenPrice || !workOrder.hidePrice) {
                    <span>{{workOrder.priceSummary | currency}}</span>
                }
            </div>
            <div class="p-col-4 hide-sm"></div>
        </div>
        @for (task of tasks; track task) {
            <div class="p-grid">
                <div class="p-col-12 p-md-5 small-bottom-padding" style="font-weight: bold;">
                    {{task.name}} [{{getTreeList(task)}}]<span class="hide-sm">, {{task.location}}</span>
                </div>
                <div class="p-col-3 hide-sm" style="text-align: right;">
                    @if ((canSeeHiddenPrice || !workOrder.hidePrice) && task.fixedPrice) {
                        <span>
                            {{task.price | currency}}
                        </span>
                    }
                    <div class="fine-print" style="text-align: right; width: 100%">
                    @if (task.minPrice || task.maxPrice) {
                        <span>Please note there will be a </span>
                    }
                    @if (task.minPrice) {
                        <span>minimum charge of {{task.minPrice | currency}}</span>
                    }
                    @if (task.minPrice && task.maxPrice) {
                        <span> and a </span>
                    }
                    @if (task.maxPrice) {
                        <span>maximum charge of {{task.maxPrice | currency}}</span>
                    }
                    </div>
                </div>
                <div class="hide-md p-col-12" style="padding: 0px !important;">
                </div>
                @if (current && showDueDates) {
                    <div class="p-col-12 p-md-4 small-top-padding">
                        {{showScheduled(task) ? 'Scheduled: ' + (task.scheduleDateFrom | date: 'shortDate') : 'Estimated Date: ' + (task.dueDateStart | date: 'shortDate') + ' - ' + (task.dueDateEnd | date: 'shortDate') }}
                    </div>
                }
                @if (!current) {
                    <div class="p-col-12 p-md-4 small-top-padding">
                        @if (task.completionStatus == CompletionStatus.Completed) {
                            <span>Completed: {{task.completedDate ? (task.completedDate | date: 'shortDate') : 'N/A'}}</span>
                        }
                        @if (task.completionStatus == CompletionStatus.Unable_to_be_Completed) {
                            <span>Unable to be Completed</span>
                        }
                        @if (task.paymentStatus) {
                            <span>&nbsp;|&nbsp;{{task.paymentStatus}}{{task.paidDate ? (': ' + (task.paidDate | date: 'shortDate')) : ''}}</span>
                        }
                        @if (!task.paymentStatus) {
                            <span>&nbsp;|&nbsp;Not Paid</span>
                        }
                    </div>
                }
                <div class="hide-md p-col-12" style="padding: 0px; padding-bottom: .5em;"></div>
            </div>
        }
    </div>
    <div class="p-col-12 p-md-4" style="text-align: right;">
        <button [ngClass]="{'view-button': pdfReceiptCount > 0 || nonPdfReceiptCount > 0}" pButton type="button" label="View Work Details" (click)="navigate()"></button>
        @if (pdfReceiptCount > 0 || nonPdfReceiptCount > 0) {
            <br/>
            <button class="receiptBtn" [ngClass]="{'view-button': pdfReceiptCount > 0 || nonPdfReceiptCount > 0}" pButton type="button"  label="View Receipts" (click)="openDialog()"></button>
        }
    </div>
</div>

@if(showReceipts) {
<div>
  <p-dialog header="Card Receipts" [(visible)]="showReceipts" [closable]="true" [style]="{width: '800px'}" [modal]="true"
    [baseZIndex]="11000" [responsive]="true" [resizable]="true" appendTo="body" (onHide)="closeDialog()">
    <!-- do an ngFor here so we can display mulitple recipts if need be -->
    @for(list of receiptList; track list) {
    <div style="width: 750px; margin-bottom: 6px;">
      <span>
        <button type="button" 
          class="btn btn-success receipt-button"  
          (click)="openNonPDFReceipts(list.receiptURLs)">
          {{ list.taskNames != "" ? list.taskNames + ' ' + list.invoiceNumber : 'View Task' + ' ' + list.invoiceNumber }}
        </button> 
      </span>
    </div>
}
  </p-dialog>
</div>
}